/** @format */
import extensionApplicationSummaryTpl from './extensionApplicationSummary.tpl.html';

export const extensionApplicationSummaryModule = 'sis-components.applications.extensionApplicationSummary';

(function () {
    angular.module(extensionApplicationSummaryModule, []).component('extensionApplicationSummary', {
        template: extensionApplicationSummaryTpl,
        bindings: {
            application: '<',
        },
    });
})();
